import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as styles from './text.css';

/**
 * Размеры текста:
 * small - 14/20
 * base - 16/22
 * h3 - 18/24
 * h2 - 22/28
 * h1 - 28/36
 */
export interface ITextProps {
  textSize?: 'base' | 'small' | 'huge' | 'h1' | 'h2' | 'h3';
  color?: 'black' | 'orange' | 'blue' | 'gray' | 'white';
  bold?: boolean;
  children?: React.ReactNode;
}

export class Text extends React.PureComponent<ITextProps, {}> {
  public render() {
    const { textSize = 'base', children, bold, color, ...rest } = this.props;

    return (
      <span {...rest} {...mergeStyles(styles[textSize], bold && styles['bold'], color && styles[color])}>
        {children}
      </span>
    );
  }
}
